








































































import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "About"
})
export default class About extends Vue {}
